import { createSelector } from '@reduxjs/toolkit';
import type { Selector } from 'types';
import { extractDomain } from 'utils/userStrings';
import { getCustomerValidEmailDomains } from './auth';
import { getEnvelopeCreatedBy } from './envelopeReview';
import { getEnvelopeRecipientsAggs, getRecipientsFromCommunication } from './envelopes';

const getThreadHighlightMode: Selector<boolean> = (state) =>
  state.ui?.envelopeView.threadHighlightMode;

export const getTranslationMode: Selector<boolean> = (state) =>
  state.ui?.envelopeView.translationMode;

export const getOpenAttachmentState: Selector<boolean> = (state) =>
  state.ui?.envelopeView.attachmentOpen;

export const getCollapsedLeftPanelState: Selector<boolean> = (state) =>
  state.ui?.envelopeView.collapsedLeftPanel;

export const getShowMoreLikeThis: Selector<boolean> = (state) =>
  state.ui?.envelopeView.showMoreLikeThis;

export const getRecipientFilter: Selector<string[]> = (state) =>
  state.ui?.envelopeView.recipientFilter;

export const getRecipientFilterCounts: Selector<{
  'after-hours': number;
  'external-domains': number;
  'higher-risk': number;
  'off-radar': number;
}> = createSelector(
  [
    getCustomerValidEmailDomains,
    getRecipientsFromCommunication,
    getEnvelopeCreatedBy,
    getEnvelopeRecipientsAggs,
  ],
  (validDomains, recipients, envelopeCreatedBy, recipientsAggs) => {
    const counts = {
      'after-hours': 0,
      'external-domains': 0,
      'higher-risk': 0,
      'off-radar': 0,
    };

    // External domains recipients
    recipients.forEach((recipient) => {
      const domain = extractDomain(recipient.id);

      if (domain && !validDomains.includes(domain)) {
        counts['external-domains'] += 1;
      }
    });

    if (envelopeCreatedBy && envelopeCreatedBy.email) {
      const domain = extractDomain(envelopeCreatedBy.email);

      if (domain && !validDomains.includes(domain)) {
        counts['external-domains'] += 1;
      }
    }

    recipientsAggs.forEach((recipient) => {
      if (recipient.afterHoursCount > 0) {
        counts['after-hours'] += 1;
      }
      if (recipient.higherRiskCount > 0) {
        counts['higher-risk'] += 1;
      }
      if (recipient.offRadarCount > 0) {
        counts['off-radar'] += 1;
      }
    });

    return counts;
  }
);

export default getThreadHighlightMode;
